export default "__VITE_ASSET__Bsk7u4Hn__"